import { useCallback, useMemo } from "react";
import { QaRules } from "@/v2/entities/sampling/Sampling.api";
import {
  ExploreFilterMenu,
  ExploreFiltersValue,
} from "../explore-filter-menu/ExploreFilterMenu";
import {
  buildFiltersFromFilter,
  parseFiltersToFilterRequest,
} from "../explore-filter-menu/explore-filter.utils";
import { isAndFilter } from "@/v2/entities/explore/Explore.filter";

interface RuleBuilderProps {
  value: QaRules;
  onChange: (value: QaRules) => void;
  allowedFields?: string[];
  size?: "1" | "2" | "3";
  viewOnly?: boolean;
}

export function RuleBuilder({
  value,
  onChange,
  allowedFields,
  size = "2",
  viewOnly,
}: RuleBuilderProps) {
  const filters = useMemo(
    () => (value ? buildFiltersFromFilter(value) : {}),
    [value]
  );

  const handleFilterChange = useCallback(
    (filters: ExploreFiltersValue) => {
      const newFilters = parseFiltersToFilterRequest(filters);

      if (!isAndFilter(newFilters)) {
        onChange(null);
        return;
      }

      if (newFilters.and.length === 0) {
        onChange(null);
        return;
      }

      onChange(newFilters);
    },
    [onChange]
  );

  return (
    <ExploreFilterMenu
      label="Add Rule"
      value={filters}
      onChange={handleFilterChange}
      size={size}
      allowedFields={allowedFields}
      viewOnly={viewOnly}
      hideCount
    />
  );
}
